'use strict'
import { App, View } from '../config/app.js'
import { Modal } from '../modal.js'
import { setCookie } from '../helper.js'

export default function ()
{
	App.Modal.PrivacyPolicy = new Modal('PrivacyPolicy',
	{
		onOpen: async (modal) =>
		{
			let topic = await App.Store.fetch('topic', 'privacy-policy-modal')
			modal.view.model.sync(
			{
				title: topic.attributes.title,
				body: topic.attributes.body
			})
		},
		onClose: () =>
		{
			if (navigator.cookieEnabled)
				setCookie(App.Config.cookieNamePrivacyAlerted, 1, 365)
			else if (window.location.href.indexOf('cookies-disabled') === -1)
				window.location.href = 'cookies-disabled'
		}
	})
}
